import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function Email() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Email Security</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Email & Cloud Protection</div>
                                <h1 className="prod-hero-title">Protect Your People from <span>Email & Cloud Threats</span></h1>
                                <p>Keep your people safe and secure. Our products are designed to protect against security vulnerabilities, malware-laden emails, phishing scams, and advanced persistent threats.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats Row */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">90%+</div>
                            <div className="prod-stat-label">Attacks Start via Email</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">99.9%</div>
                            <div className="prod-stat-label">Threat Detection Rate</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">0-Day</div>
                            <div className="prod-stat-label">Zero-Day Protection</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">24/7</div>
                            <div className="prod-stat-label">Continuous Monitoring</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Targeted Attack Protection */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/email-protech.webp')} alt="Targeted Attack Protection" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Core Protection</div>
                                <h2>Targeted Attack Protection</h2>
                                <p>More than 90% of targeted attacks start with email — and these threats are constantly evolving. Cloud Mind Targeted Attack Protection (TAP) detects, analyzes, and blocks advanced threats before they reach your inbox.</p>
                                <p>This includes ransomware, polymorphic malware, weaponized documents, and phishing attacks, along with zero-day threat protection and adaptive controls to isolate the riskiest URL clicks.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '8px', display: 'inline-flex' }}>
                                    Learn More <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4 Feature Cards */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Our Solutions</div>
                        <h2 className="prod-section-title">Comprehensive <span>Email Security</span> Suite</h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>End-to-end protection across your entire email and cloud ecosystem</p>
                    </div>
                    <div className="prod-features-grid">
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/expt-1.webp')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>DMARC Authentication</h4>
                            <p>Domain-based Message Authentication, Reporting &amp; Conformance. Verifies email senders and protects against domain spoofing using DNS, DKIM, and SPF protocols.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/expt-2.webp')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Advanced Threat Protection</h4>
                            <p>Comprehensive security against malware, phishing, and sophisticated cyberattacks. Combines cloud security, email security, and endpoint protection technologies.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                            <h4>Email Fraud Defense</h4>
                            <p>Simplifies DMARC authentication to prevent email fraud and protect your trusted domain. Provides insights into fraud risks posed by suppliers and partners.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-bolt"></i></div>
                            <h4>Threat Response (SOAR)</h4>
                            <p>Security orchestration, automation, and response solution. Empowers teams to respond faster to the evolving threat landscape and overcome alert overload.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Email Security & Fraud Defense Alternating */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="row align-items-center mb-5 pb-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                        <div className="col-lg-6 order-lg-2">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/email-security.webp')} alt="Email Security" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="prod-info-content" style={{ paddingLeft: 0, paddingRight: 40 }}>
                                <div className="prod-section-label">Layer 1</div>
                                <h2>Email Security &amp; Protection</h2>
                                <p>Comprehensive defense against advanced threats including phishing, ransomware, and malware. Our solution proactively detects and blocks malicious attachments, URLs, and suspicious activity, safeguarding your inbox and cloud applications from evolving email-based risks.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center mt-5 pt-2">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/email-froud.jpg')} alt="Email Fraud Defense" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Layer 2</div>
                                <h2>Email Fraud Defense</h2>
                                <p>Helps secure your email channel and restore trust in business communications. By simplifying DMARC authentication, it prevents email fraud and protects your trusted domain. Beyond DMARC, it provides insights into fraud risks posed by suppliers.</p>
                                <p>Email is the most critical business communication channel and the top threat vector for organizations. Keep it secure with CLOUD MIND Email Fraud Defense.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Web Security */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/web-security.webp')} alt="Web Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Layer 3</div>
                                <h2>Web Security</h2>
                                <p>Focuses on protecting data and network resources from online threats. By combining monitoring tools, user training, and robust strategies, we safeguard your infrastructure and people from cyber-attacks.</p>
                                <p>Advanced web security includes a proxy between users and browsers to block malware and persistent threats, ensuring your digital presence remains secure.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '8px', display: 'inline-flex' }}>
                                    Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Threat Response */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-2">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/threat-response.webp')} alt="Threat Response" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="prod-info-content" style={{ paddingLeft: 0, paddingRight: 40 }}>
                                <div className="prod-section-label">Response Solutions</div>
                                <h2>Threat Response Solutions</h2>
                                <p>CLOUD MIND Threat Response helps security teams overcome challenges such as staff shortages, alert overload, and long response times. As a leading SOAR solution, it empowers teams to respond faster and more efficiently to the evolving threat landscape.</p>
                                <ul className="prod-benefits-list mt-3">
                                    <li><span className="ben-dot">✓</span>Automated threat investigation and triage</li>
                                    <li><span className="ben-dot">✓</span>Real-time alert correlation and prioritization</li>
                                    <li><span className="ben-dot">✓</span>Faster incident response and remediation</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Secure Your Email Environment?</h3>
                            <p>Talk to our security experts and get a customized protection plan for your organization.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
